import { productPromotionConstants } from "../constants";
import { productPromotionService } from "../services";
import { alertActions } from '.';

export const productPromotionAction = {
    refund,
    payout,
}

function payout(id,data) {
  return dispatch => {
      return new Promise((resolve, reject) => {
        productPromotionService.payout(id,data)
          .then(
              data => {
                  dispatch(success(data));
                  dispatch(alertActions.success(data.message[0]));
                  resolve(data)
              },
              error => {
                  dispatch(alertActions.error(error.toString()));
                  reject()
              }
          );
      });
  };
  function success(data) { return { type: productPromotionConstants.GET_PP_SUCCESS, payload:data } }
}

function refund(id,data) {
  return dispatch => {
      return new Promise((resolve, reject) => {
        productPromotionService.refund(id,data)
          .then(
              data => {
                  dispatch(success(data));
                  dispatch(alertActions.success(data.message[0]));
                  resolve(data)
              },
              error => {
                  dispatch(alertActions.error(error.toString()));
                  reject()
              }
          );
      });
  };
  function success(data) { return { type: productPromotionConstants.GET_PP_SUCCESS, payload:data } }
}
